import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../IconButton/IconButton';
import { classes } from '../Carousel.st.css.js';
const skinPriorityMap = {
    standard: 'secondary',
    inverted: 'primary',
    light: 'primary',
    transparent: 'primary',
    premium: 'primary',
};
const SliderArrow = (_a) => {
    var { dataHook, arrowSize, buttonSkin, icon, className, controlsStartEnd } = _a, remainingProps = __rest(_a, ["dataHook", "arrowSize", "buttonSkin", "icon", "className", "controlsStartEnd"]);
    const isControlOnEdge = className.includes('slick-disabled');
    return isControlOnEdge && controlsStartEnd === 'hidden' ? null : (React.createElement("div", Object.assign({}, remainingProps, { "data-hook": dataHook, className: className }),
        React.createElement(IconButton, { dataHook: `${dataHook}-element`, className: classes.controls, skin: buttonSkin, size: arrowSize, disabled: isControlOnEdge, priority: skinPriorityMap[buttonSkin] }, icon)));
};
SliderArrow.propTypes = {
    /** Applied as data-hook HTML attribute that can be used in the tests */
    dataHook: PropTypes.string,
    /** Icon to be rendered within the icon button */
    icon: PropTypes.element.isRequired,
};
export default SliderArrow;
//# sourceMappingURL=SliderArrow.js.map